import React from 'react'
import { PriceString } from '../../../../../../functional/PriceString'
import * as S from './styled'
import type { Props } from './types'

export const AccordionHeading = ({ quantity, isMinimumQuantity, profit, showProfit }: Props) => {
  return (
    <S.Container>
      <S.Quantity>
        {quantity} sold {isMinimumQuantity && <span>(minimum)</span>}
      </S.Quantity>
      {showProfit && (
        <div>
          <PriceString value={profit} /> profit
        </div>
      )}
    </S.Container>
  )
}
